import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatSort} from '@angular/material/sort';
import {NICESkill} from "../../models/NICE_Skill.model";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {NICEDisposition} from "../../models/NICE_Disposition.model";
import { ChangeDetectorRef } from '@angular/core';
import {IcDataService} from "../../services/ic-data.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    selector: 'app-reorder-dispositions-dialog',
    templateUrl: './reorder-dispositions-dialog.component.html'
})
export class ReorderDispositionsDialogComponent implements OnInit {

    dataSource: MatTableDataSource<NICESkill> = new MatTableDataSource();
    selection = new SelectionModel<NICESkill>(true, []);
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    filterObj: { searchString: string; showAll: boolean } = {searchString: '', showAll: false};
    currentSkill: NICESkill;
    updatedSkill: NICESkill = {} as NICESkill;
    dispositions: NICEDisposition[] = [];
    saveDisabled: boolean;

    constructor(public dialogRef: MatDialogRef<ReorderDispositionsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: ReorderDispositionsDialogModal,
                private icData: IcDataService,
                private cd: ChangeDetectorRef,
                private _matSnackBar: MatSnackBar) {
    }
    ngOnInit(): void {
        this.currentSkill = this.data.currentSkill;
        this.dispositions = [...this.currentSkill.dispositions];
        this.updatedSkill.skillId = this.currentSkill.skillId;
        this.updatedSkill.dispositions = [...this.currentSkill.dispositions];
    }

    onConfirm(): void {
        this.dialogRef.close(this.updatedSkill);
    }
    onDismiss(): void {
        // Close the dialog, return false
        this.currentSkill.dispositions = this.dispositions;
        this.dialogRef.close(false);
    }
    drop(event: CdkDragDrop<NICEDisposition[]>):
        void {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex
        );
        this.updatedSkill.dispositions = event.container.data;
    }
    removeDisposition(disposition: NICEDisposition):
        void {
        //remove dispo from list but do not update the skill until SAVE
        const dispositionIndex = this.currentSkill.dispositions.indexOf(disposition);
        this.currentSkill.dispositions.splice(dispositionIndex, 1);
        this.updatedSkill.dispositions = this.currentSkill.dispositions;
        this.saveDisabled = false;
        //this.dialogRef.close(this.updatedSkill);
    }
}

export class ReorderDispositionsDialogModal {
    constructor(
        public currentSkill: NICESkill
    ) {
    }
}
